export default "__VITE_ASSET__BwEgx52z__"